import {ValueObject} from '@s-ui/domain'

import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'
import {SpecificationsVehiclesValueObject} from './SpecificationsVehiclesValueObject.js'

const MAX_SUGGESTED_VEHICLES = 10

export class SuggestedVehiclesValueObject extends ValueObject {
  #suggestions

  constructor({suggestions}) {
    super()
    this.#suggestions = suggestions
  }

  static createFromApiResponse({items = []} = {}) {
    const suggestions = items.map(item => ({
      label: StringSharedValueObject.createFromPrimitives({value: item.label}),
      vehicles: item.vehicles?.length
        ? item.vehicles
            .slice(0, MAX_SUGGESTED_VEHICLES)
            .map(vehicle => SpecificationsVehiclesValueObject.createFromSuggestionApi(vehicle))
        : []
    }))

    return new SuggestedVehiclesValueObject({suggestions})
  }

  get suggestions() {
    return this.#suggestions
  }

  get value() {
    return {
      suggestions: this.#suggestions.map(item => ({
        label: item.label.value,
        vehicles: item.vehicles.map(vehicle => vehicle.value)
      }))
    }
  }
}
